module.exports = __webpack_public_path__ + "media/images/cbjj/logo-cbjj-white-footer-ed4d3da0cb6b2b1efb35bef4b04af66f.png";